import React from "react";
import "./home.scss";
import Navbar from "../Section/Header/navbar";
import Banner from "../Section/Banner/banner";
import New from "../Section/Soon/Csoon";
import About from "../Section/About/about";
import Launching from "../Section/New Mahakam/NMahakam";
import Promo from "../Section/Newlaunch/Newlaunch";
import Aboutproduk from "../Section/ProdukAbout/Aboutproduk";
import Produk from "../Section/Produk/Produk";
import Ruko from "../Section/Ruko/Ruko";
import Kavling from "../Section/Kavling/Kavling";
import Surrounding from "../Section/Surrounding/Surrounding";
import Lokasi from "../Section/Lokasi/lokasi";
import Footer from "../Section/Footerup/footerup";
import Scrolltohashelement from "../Pages/ScrollToHashElement";
import tombol from "../Media/tombol.webp";
const home = () => {
  const fungsiganteng = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=628111607096&text=Halo%20Andrian,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20jakarta%20Garden%20City%20https://marketing-jakartagardencity.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  return (
    <div className="home">
      <Scrolltohashelement />
      <Navbar />
      <Banner />
      <About />
      <New />
      <Launching />
      <Promo />
      <Aboutproduk />
      <Produk />
      <Ruko />
      <Kavling />
      <Surrounding />
      <Lokasi />
      <Footer />
      <img
        onClick={fungsiganteng}
        src={tombol}
        className="tombolwa"
        alt="Hubungi Sekarang!"
      />
    </div>
  );
};

export default home;
